module.exports = __webpack_public_path__ + "49ac47443021435f129d714f49ab6fc7.pdf";